import { Types } from '@fiverr-private/theme';
import { paddingX_0_xxl_class } from '../helpers/styles.ve.css';

export const CENTERED: Types.LayoutType = {
    padding: {
        default: '6',
        md: '8',
    },
    paddingBottom: {
        default: '12',
        md: '16',
    },
    maxWidth: {
        default: '1400px',
    },
    width: { default: '100%' },
    margin: { default: 'autoX' },
    className: paddingX_0_xxl_class,
};
